__turbopack_context__.v({
  "chip": "Chip-module__RhvrpG__chip",
});
